import theme from '../../theme/theme';

const {
  colors: { collapse_border, clear_text },
} = theme;

const styles = {
  header: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    height: '4.625em',
    borderRadius: '0px',
    justifyContent: 'center',
  },

  icons__right: {
    height: '2.125em',
    paddingRight: '0.625em',
    paddingLeft: '0.750em',
    right: 0,
    position: 'absolute',
  },

  icons__left: {
    height: '2.125em',
    paddingRight: '0.625em',
    paddingLeft: '0.750em',
    left: 0,
    position: 'absolute',
  },

  collapse__border: {
    fontSize: '1.375em',
    borderRadius: '0.188em',
    background: collapse_border,
    right: 0,
    top: 0,
    marginTop: '1em',
    marginRight: '.875em',
    position: 'absolute',
  },

  collapse__icon: {
    padding: '0.165em',
    fontSize: '2.750em',
  },

  clear: {
    color: clear_text,
    fontFamily: 'semibold',
    fontSize: '1.250em',
    fontWeight: 600,
    letterSpacing: '-0.031em',
    textAlign: 'right',
    right: 0,
    paddingTop: '.23em',
    paddingRight: '1.5em',
    position: 'absolute',
  },
};

export default styles;
